/**
 * 功能开关：央行监督放款（BoFu / jiandu）
 * false = 正式服不上线展示（关弹窗、关路由）
 * true  = 恢复展示
 */
export const ENABLE_JIAN_DU_BO_FU = true;

/**
 * 功能开关：预约取款钱包提现额度限制
 * false = 关闭额度限制（可按钱包余额提现）
 * true  = 启用额度限制
 */
export const ENABLE_WITHDRAW_QUOTA_LIMIT = false;
